import { Ng2SmartTableModule } from 'ng2-smart-table';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt);

import { AppRoutingModule } from './app-routing.module';
import { NbDateFnsDateModule } from '@nebular/date-fns'
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbDialogRef,
  NbCardModule,
  NbAutocompleteModule,
  NbIconModule,
  NbListModule,
  NbInputModule,
  NbLayoutModule,
  NbButtonModule,
  NbThemeModule,
  NbSelectModule,
} from '@nebular/theme';
import { NbAuthModule, NbDummyAuthStrategy } from '@nebular/auth';
import { InterceptorModule } from './interceptor/token.interceptor.module';
import { DataNavigation } from './util/dataNavigation';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ComponentLoaderFactory } from 'ngx-bootstrap/component-loader';
import { PositioningService } from 'ngx-bootstrap/positioning';
import { ConfirmPopupComponent } from './dialog/confirm-popup/confirm-popup.component';
import { NgxMaskModule } from 'ngx-mask';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { ErrorPopupComponent } from './dialog/error-popup/error-popup.component';
import { ViewPopupComponent } from './dialog/view-popup/view-popup.component';
import { NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ComponentsModule } from './components/components.module';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { TermsOfUseComponent } from './dialog/terms-of-use/terms-of-use.component';
import { CookiesBottomSheetComponent } from './dialog/cookies-bottom-sheet/cookies-bottom-sheet.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CodeSentComponent } from './dialog/code-sent/code-sent.component';
import { PopupAdvertisementComponent } from './dialog/popup-advertisement/popup-advertisement.component';
import { LobbyPanelModule } from './panel/lobby-panel/lobby-panel.module';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ServerCommunicationErrorComponent } from './dialog/server-communication-error/server-communication-error.component';
import { ImgPopupComponent } from './dialog/img-popup/img-popup.component';
import { NotifyUserExistingAuthComponent } from './dialog/notify-user-existing-auth/notify-user-existing-auth.component';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ImageViewComponent } from './dialog/image-view/image-view.component';

export function HttpLoaderFactory(http: HttpClient){
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    ConfirmPopupComponent,
    ImageViewComponent,
    ErrorPopupComponent,
    ViewPopupComponent,
    TermsOfUseComponent,
    CookiesBottomSheetComponent,
    CodeSentComponent,
    PopupAdvertisementComponent,
    ServerCommunicationErrorComponent,
    ImgPopupComponent,
    NotifyUserExistingAuthComponent,
  ],
  imports: [
    ComponentsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    Ng2SmartTableModule,
    ThemeModule.forRoot(),
    InterceptorModule,
    NbAutocompleteModule,
    NbLayoutModule,
    NbInputModule,
    NbListModule,
    InfiniteScrollModule,
    NbIconModule,
    NbButtonModule,
    NbEvaIconsModule,
    NgxMaskModule,
    NbCardModule,
    FormsModule,
    NbSelectModule,
    ReactiveFormsModule,
    NgxMaterialTimepickerModule,
    MatBottomSheetModule,
    LobbyPanelModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDateFnsDateModule.forRoot({ format: 'dd/MM/yyyy' }),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbDialogModule.forChild(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    // deixar o calendario em portugues    
    NbThemeModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    NbAuthModule.forRoot({
      strategies: [
        NbDummyAuthStrategy.setup({
          name: 'email',
          alwaysFail: true,
          delay: 1000,
        }),
      ],
    }),

    TranslateModule.forRoot({
      defaultLanguage: 'pt',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NbThemeModule.forRoot({ name: 'default' }),
    NgxGoogleAnalyticsModule.forRoot('G-779SX9V83T'),
    NgxGoogleAnalyticsRouterModule.forRoot({ include: [ '/page-*' ] }),
  ],
  bootstrap: [AppComponent],
  providers: [DataNavigation,
    BsModalService,
    ComponentLoaderFactory,
    PositioningService,
    { provide: LOCALE_ID, useValue: 'pt-BR' },],
  // exports: [UserCardComponent]
})
export class AppModule {
}
